export default (
	options = []
) => ({
	options,
	multiple: false,
	type: '',
	ready: false, 
	init() {
		this.$nextTick( () => {
			let type = new URLSearchParams(location.search).get('type');
			if ( type ) {
				this.type = type;
				this.$dispatch('filter', { field: 'type', value: type });
			}
			this.ready = true;
		} );
		this.$watch('type', (value) => {
			if ( !this.ready ) { return; }

			const url = new URL(window.location.href);
			url.searchParams.set('type', value);
			history.pushState(null, document.title, url.toString());
		});
	}
});

